module.exports = __webpack_public_path__ + "img/picture_viptk01.54cf361f.png";